import _reduce from 'lodash-es/reduce';
import _isEqual from 'lodash-es/isEqual';

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

import { TileLayer } from 'leaflet';

import PropTypes from 'prop-types';

import GridLayer from './GridLayer';
import { EVENTS_RE } from './MapComponent';
import children from './propTypes/children';

var WMSTileLayer = function (_GridLayer) {
  _inherits(WMSTileLayer, _GridLayer);

  function WMSTileLayer() {
    _classCallCheck(this, WMSTileLayer);

    return _possibleConstructorReturn(this, _GridLayer.apply(this, arguments));
  }

  WMSTileLayer.prototype.createLeafletElement = function createLeafletElement(props) {
    var url = props.url,
        params = _objectWithoutProperties(props, ['url']);

    return new TileLayer.WMS(url, this.getOptions(params));
  };

  WMSTileLayer.prototype.updateLeafletElement = function updateLeafletElement(fromProps, toProps) {
    _GridLayer.prototype.updateLeafletElement.call(this, fromProps, toProps);

    var prevUrl = fromProps.url,
        _po = fromProps.opacity,
        _pz = fromProps.zIndex,
        prevParams = _objectWithoutProperties(fromProps, ['url', 'opacity', 'zIndex']);

    var url = toProps.url,
        _o = toProps.opacity,
        _z = toProps.zIndex,
        params = _objectWithoutProperties(toProps, ['url', 'opacity', 'zIndex']);

    if (url !== prevUrl) {
      this.leafletElement.setUrl(url);
    }
    if (!_isEqual(params, prevParams)) {
      this.leafletElement.setParams(params);
    }
  };

  WMSTileLayer.prototype.getOptions = function getOptions(params) {
    return _reduce(_GridLayer.prototype.getOptions.call(this, params), function (options, value, key) {
      if (!EVENTS_RE.test(key)) {
        options[key] = value;
      }
      return options;
    }, {});
  };

  return WMSTileLayer;
}(GridLayer);

WMSTileLayer.propTypes = {
  children: children,
  opacity: PropTypes.number,
  url: PropTypes.string.isRequired,
  zIndex: PropTypes.number
};
export default WMSTileLayer;


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/es/WMSTileLayer.js
// module id = 2453
// module chunks = 0